import { Grid, Typography, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import DateFormatter from '~/modules/billing-invoicing/common/components/AvailableToBillListTable/columns/formatters/date';
import ClientFormatter from '~/modules/billing-invoicing/common/components/AvailableToBillListTable/columns/formatters/client';

const useStyles = makeStyles(theme => ({
  name: {
    fontWeight: theme.typography.fontWeightBold
  },
  container: {
    padding: theme.spacing(1, 0, 1)
  },
  date: {
    color: theme.palette.text.secondary
  }
}));

export const MobileAvailableToBillHeaderRow = ({ record }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      alignItems="center"
      spacing={0}
      className={classes.container}
    >
      <Grid item xs={6}>
        <Typography className={classes.name} variant="body2" component="div">
          <FormattedMessage id="mobileAvailableToBillHeaderRow.availableToBill" />
        </Typography>
        <div className={classes.date}>
          {DateFormatter({
            record,
            variant: 'caption'
          })}
        </div>
      </Grid>
      <Grid item xs={6}>
        <ClientFormatter field="client" record={record} />
      </Grid>
    </Grid>
  );
};

MobileAvailableToBillHeaderRow.propTypes = {
  record: PropTypes.object
};

export default MobileAvailableToBillHeaderRow;
